exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".link[data-v-596b6635]{color:#000;display:inline-block;width:120px}.count[data-v-596b6635]{font-size:14px}.list[data-v-596b6635]{list-style:none;padding-left:0}.list li[data-v-596b6635]{margin:0;text-align:center;float:left;padding:15px 15px 15px 0}.avatar[data-v-596b6635]{width:64px;height:64px;border-radius:40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"autoprefixer":false,"sourceMap":false,"minimize":true}!./~/ream/~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-596b6635","scoped":true,"hasInlineConfig":true}!./~/ream/~/vue-loader/lib/selector.js?type=styles&index=0!./zh-CN/about/contributors.vue
// module id = 1436
// module chunks = 170